import React, { FC } from 'react'
import { ToCommentObjectType } from '../types/models/Comment'
import { OutputAuthorType } from '../types/models/User'
import Styles from "../styles/ToComment.module.scss"
import UserAvatar from './UserAvatar'
import clsx from "clsx"

type Props = {
    toCommentAuthor: OutputAuthorType
    toComment: ToCommentObjectType
    onMyComment: boolean
    scrollToComment: ( { commentPk, blink }: { commentPk: string, blink: boolean } ) => void
}

export const ToComment: FC<Props> = ( { toComment, toCommentAuthor, onMyComment, scrollToComment } ) => {

    return (
        <div
            className={ clsx( Styles.to_comment_container, onMyComment && Styles.on_my_comment ) }
            onClick={ () => scrollToComment( { commentPk: toComment.pk, blink: true } ) }>
            { toComment.deleted ?
                null :
                <p className={ Styles.to_comment_author }>
                    { toCommentAuthor.pk ?
                        <UserAvatar
                            userID={ toCommentAuthor.pk }
                            userName={ toCommentAuthor.name }
                            size={ 24 }
                            avatarSize={ 12 }
                            style={ { height: 24, width: 24 } }
                            noTransition={ true }
                            profileImageURL={ toCommentAuthor.profile_image_100 } /> :
                        <UserAvatar
                            userName={ toCommentAuthor.name }
                            size={ 24 }
                            avatarSize={ 12 }
                            style={ { height: 24, width: 24 } }
                            noTransition={ true } /> }
                    { toComment.author }
                </p>
            }
            <p className={ Styles.to_comment_text }>{ toComment.text }</p>
        </div>
    )
}
